import {
	ElementRef,
	TemplateRef
}                         from '@angular/core';
import { DeviceTypeEnum } from '@appConfig/media-config';


// ENUMS #############################################################
export enum AllowedDetailsTabEnum {
	ARCHIVING_DOCUMENTATION = 'archiving-documentation',
	ARCHIVING_DOCUMENTATION_EXPORT = 'archiving-documentation-export',
	ARCHIVING_DOCUMENT = 'archiving-document',
	ARCHIVING_EXPORT = 'archiving-export',
	ARCHIVING_EXPORT_ITEMS = 'archiving-export-items',
	ARCHIVING_TSS_LOG_EXPORT = 'archiving-tss-log-export',
	ARCHIVING_TSS_LOGS = 'archiving-tss-logs',
	CASH_POINT_CLOSING = 'cash-point-closings',
	CONTRACT_CHANGELOG = 'changelog',
	CONTRACTS = 'contracts',
	DETAILS = 'details',
	DTR_VOLUME = 'dtr-volume',
	ENCRYPTION_KEY = 'encryption-key',
	ERS = 'ers',
	ERRORS = 'errors',
	FCC = 'fcc',
	DEVICES = 'devices',
	FISKAL_TSS_LOGS = 'fiskal-tss-logs',
	GK_USAGE = 'gk-usage',
	IMPORTS = 'imports',
	INSTALLATION_DETAILS = 'installation-details',
	INTERNAL = 'internal',
	OPEN_ARCHIVE = 'open-archive',
	OPEN_ARCHIVE_EXPORT = 'open-archive-export',
	PACKAGES = 'packages',
	ORGANIZATION_BUSINESS_PREMISES = 'organization-business-premises',
	OUTAGES = 'outages',
	SOFTWARE_MANIFESTS = 'software-manifests',
	SOFTWARE_MANIFESTS_INSTALLATIONS = 'software-manifest-installations',
	STATISTICS = 'statistics',
	SUBTENANTS = 'subtenants',
	TAXATION_REPORTING = 'taxationReporting',
	TENANTS = 'tenants',
	USER_AUDIT = 'user-audit'
}

export enum AllowedTabSetEnum {
	ARCHIVE = 'archive',
	ARCHIVING_USAGE = 'archiving-usage',
	CONTRACT = 'contracts',
	DTR_USAGE = 'dtr-usage',
	ELSTER = 'elster',
	FCC_VERSIONS = 'fcc-versions',
	FISCAL = 'fiscal',
	FISKAL_USAGE = 'fiskal-usage',
	GK_USAGE = 'gk-usage',
	SIGNATURES = 'signatures',
	STATISTICS = 'statistics',
	TAXATION_REPORTING = 'taxation-reporting',
	USERS = 'users',
}

export enum AvailabilityStatusColorEnum {
	SUCCESS = 'success',
	WARN = 'warn',
}

export enum ProductEnum {
	ARCHIVE = 'archive',
	ELSTER = 'elster',
	FISCAL = 'fiscal',
}

export enum ObservableTypeEnum {
	COLD = 'cold',
	HOT = 'hot'
}

export interface IDomTreeChangeData {
	element: any;
	mutationRecords: MutationRecord[];
}


// INTERFACES ########################################################
export interface IKeyValueMap<T> {
	[ key: string ]: T;
}

export interface IScrollDataBase {
	target: any;
	clientTop: number;
	clientLeft: number;
	clientWidth: number;
	clientHeight: number;
	offsetTop: number;
	offsetLeft: number;
	offsetWidth: number;
	offsetHeight: number;
	scrollTop: number;
	scrollLeft: number;
	scrollWidth: number;
	scrollHeight: number;
}

export interface IScrollData extends IScrollDataBase {
	targetFitMaxHeight?: number;
	offsetParent?: IScrollDataBase;
}

export interface ISelectionData<T> {
	keepSelection: boolean;
	selectedItems: T[]
}

// Tab Data Interfaces *********************************************************
export interface ITabContent {
	/** key of the entity property */
	key: string;
	order: number;
	i18nPath: string;
	format?: string;
	translateValuePath?: string;
	addSpaceToPrevious?: boolean;
	showOnDevices?: DeviceTypeEnum[];
	copyClipboard?: boolean;
	infoPath?: string;
	actionItemsRef?: TemplateRef<ElementRef>;
}

export interface ITabItem {
	i18nTitlePath: string;
	tabIdentifier?: AllowedDetailsTabEnum;
	tabId?: number;
	tabContentPanelClass?: string;
	navAdditionalText?: string;
	disabled?: boolean;
	tabItemStyleClass?: string;
	template?: {
		navRef?: {
			navRefPrependedContent?: TemplateRef<ElementRef>;
			navContext?: any;
			navRefAppendedContent?: TemplateRef<ElementRef>;
		};
		useBaseContentRefType?: AllowedDetailsTabEnum;
		contentRef?: TemplateRef<ElementRef>;
		contentContext?: {
			[ key: string ]: any;
			contentValueOverwrite?: ITabItemContentValueOverwrite;
		};
	};
}

export interface ITabItemContentValueOverwrite {
	[ key: string ]: {
		templateRef: TemplateRef<ElementRef>;
		templateContext?: any;
	};
}
